// A lookup table of our Slack webhooks.
// The key should be the Slack channel that messages post to.
//
// ex: #feed-feature-requests -> SLACKS_WEBHOOKS.FEED_FEATURE_REQUESTS

import { commonStore } from "stores/commonStore";
import { ENV } from "./hostEnv";

export const SLACK_WEBHOOKS = {
  FEED_FEATURE_REQUESTS: `${ENV.SLACK_WEBHOOKS_ENDPOINTS}feature-request`,
  FEED_SERVICE_DELETION_SUBMISSIONS: `${ENV.SLACK_WEBHOOKS_ENDPOINTS}service-deletion`,
  FEED_CRYTPTO_REQUEST: `${ENV.SLACK_WEBHOOKS_ENDPOINTS}crypto-request`,
  PROJECT_CHUNK_INTERVAL_AUTOTUNE: `${ENV.SLACK_WEBHOOKS_ENDPOINTS}chunk-auto-tune`,
};

type Field = {
  label: string;
  value: string;
};

type Block = {
  type: string;
  fields: Field[];
};

export const produceBlocksPayload = (sectionFields: Field[][]) =>
  sectionFields.map((fields) => ({
    type: "section",
    fields,
  }));

export async function submitSlackMessage(title: string, blocks: Block[]) {
  const data = {
    blocks: [
      {
        type: "header",
        text: {
          type: "plain_text",
          text: title,
        },
      },
      ...blocks.map((block) => ({
        type: block.type,
        fields: block.fields.map((field) => ({
          type: "mrkdwn",
          text: `*${field.label}:*\n${field.value}`,
        })),
      })),
    ],
  };

  const success = await commonStore.postSlackWebhook(
    JSON.stringify(data),
    false,
  );

  return success;
}
